// reducers.js
import {combineReducers} from "redux";
import {connectRouter} from "connected-react-router";
import {
  getEstimatedValue,
  getOutstandingBalance,
  getHpInterestRate,
  getInternalSalePrice
} from "../utils";
import {getLastMonthInterest, getRemainingInterest, getThisMonthsPayment} from "../financeUtils";

const initialState = {
  vehicle: {inspections: [], finance_agreements: [], finance_type: "NONE"},
  figures: {},
  dataFresh: 0,
  inspections: {results: [], count: 0},
  parts: {results: [], count: 0},
  partLookup: {results: [], count: 0},
  quickLinks: {results: [], count: 0}
};

export const dataReducer = (state = initialState, action) => {
    switch (action.type) {
      case "Data/SetJobsData":
        return {
          ...state,
          jobs: action.data
        };
      case "Data/SetQuotesData":
        return {
          ...state,
          quotes: action.data
        };
      case "Data/SetPartsData":
        return {
          ...state,
          parts: action.data
        };
      case "Data/SetPartLookupData":
        return {
          ...state,
          partLookup: action.data
        };
      case "Data/SetWorkLookupData":
        return {
          ...state,
          workLookup: action.data
        };
      case "Data/SetRentalsData":
        return {
          ...state,
          rentals: action.data
        };
      case "Data/SetRentalInvoiceData":
        return {
          ...state,
          rentalInvoices: action.data
        };
      case "Data/SetUserData":
        return {
          ...state,
          user: action.data
        };
      case "Data/SetTransactionData":
        return {
          ...state,
          transactions: action.data
        };
      case "Data/SetWeeklyTransactionData":
        return {
          ...state,
          weeklyTransactions: action.data
        };
      case "DataFresh/SetDataFresh":
        return {
          ...state,
          dataFresh: action.dataFresh
        };
      case "Data/SetPartsFiguresData":
        return {
          ...state,
          figures: {
            ...state.figures,
            partFigures: action.data
          }
        };
      case "Data/SetWorkFiguresData":
        return {
          ...state,
          figures: {...state.figures, workFigures: action.data}
        };
      case "Data/SetTransactionFiguresData":
        return {
          ...state,
          figures: {...state.figures, transactionData: action.data}
        };
      case "Data/SetRentalFiguresData":
        return {
          ...state,
          figures: {...state.figures, rentalFigures: action.data}
        };
      case "Data/SetVehicleFiguresData":
        return {
          ...state,
          figures: {...state.figures, vehicleFigures: action.data}
        };
      case "Data/SetTargetFiguresData":
        return {
          ...state,
          figures: {...state.figures, target: action.data}
        };
      case "Data/SetVehicleSummaryFigureData":
        return {
          ...state,
          figures: {...state.figures, vehicleSummary: action.data}
        };
      case "Data/SetTargetsData":
        return {
          ...state,
          targets: action.data
        };
      case "Data/SetInspectionTypesData":
        return {
          ...state,
          inspectionTypes: action.data
        };
      case "Data/SetInspectionData":
        return {
          ...state,
          inspections: action.data
        };
      case "Data/SetPaymentsData":
        return {
          ...state,
          payments: action.data
        };
      case "Data/SetRecurringPaymentsData":
        return {
          ...state,
          recurringPayments: action.data
        };
      case "Data/SetVehicleTypesData":
        return {
          ...state,
          vehicleTypes: action.data
        };
      case "Data/SetTransactionCategoriesData":
        return {
          ...state,
          transactionCategories: action.data
        };
      case "Data/SetTransactionReportingCategoriesData":
        return {
          ...state,
          transactionReportingCategories: action.data
        };
      case "Data/SetCostCentresData":
        return {
          ...state,
          costCentres: action.data
        };
      case "Data/SetVehicleData":
        return {
          ...state,
          vehicle: {
            ...action.data,
            finance_agreements: action.data.finance_agreements.map(agreement => {
              return {
                ...agreement,
                remaining_balance: getOutstandingBalance({...agreement}),
                hp_remaining_interest: getRemainingInterest({...agreement}, new Date(Date.now())),
                early_settlement_charges: 1 * getOutstandingBalance({...agreement}) + 1 * getLastMonthInterest({...action.data}, new Date(Date.now())),
                estimated_value: getEstimatedValue({...agreement}),
                this_months_payment: getThisMonthsPayment(
                  {...agreement},
                  new Date(Date.now())
                )
              }
            }),
            remaining_balance: getOutstandingBalance({...action.data}),
            hp_remaining_interest: getRemainingInterest({...action.data}, new Date(Date.now())),
            early_settlement_charges: 1 * getOutstandingBalance({...action.data}) + 1 * getLastMonthInterest({...action.data}, new Date(Date.now())),
            // estimated_value: getEstimatedValue({...action.data})
          }
        };
      case "Data/SetVehicleTrackersData":
        return {
          ...state,
          trackers: action.data ?? state.trackers
        };
      case "Data/SetVehicleField":
        return {
          ...state,
          vehicle: {
            ...state.vehicle,
            ...action.data,
            remaining_balance: getOutstandingBalance({
              ...state.vehicle,
              ...action.data
            }),
            early_settlement_charges: getOutstandingBalance({
              ...state.vehicle,
              ...action.data
            }) + getLastMonthInterest({...action.data}, new Date(Date.now())),
            hp_remaining_interest: getRemainingInterest(
              {
                ...state.vehicle,
                ...action.data
              }, new Date(Date.now())
            ),
            // estimated_value: getEstimatedValue({
            //   ...state.vehicle,
            //   ...action.data
            // }),
            hp_interest_rate: getHpInterestRate({
              ...state.vehicle,
              ...action.data
            }),
            internal_sale_price: getInternalSalePrice({
              ...state.vehicle,
              ...action.data
            }),
            finance_agreements: action.data.finance_agreements ? action.data.finance_agreements.map(agreement => {
              return {
                ...agreement,
                remaining_balance: getOutstandingBalance({...agreement}),
                hp_remaining_interest: getRemainingInterest({...agreement}, new Date(Date.now())),
                early_settlement_charges: 1 * getOutstandingBalance({...agreement}) + 1 * getLastMonthInterest({...agreement}, new Date(Date.now())),
                estimated_value: getEstimatedValue({...agreement}),
                hp_interest_rate: getHpInterestRate({
                  ...agreement,
                }),
                internal_sale_price: getInternalSalePrice({
                  ...agreement
                }),
                this_months_payment: getThisMonthsPayment(
                  {...agreement},
                  new Date(Date.now())
                )
              }
            }) : state.vehicle.finance_agreements,
          }
        };
      case "Data/SetVehicleSummaryData":
        return {
          ...state,
          vehicleSummary: {
            ...action.data
          }
        };
      case "Data/SetJobData":
        return {
          ...state,
          job: {
            ...action.data
          }
        };
      case "Data/SetRentalData":
        return {
          ...state,
          rental: {
            ...action.data
          }
        };
      case "Data/SetQuoteData":
        return {
          ...state,
          quote: {
            ...action.data
          }
        };
      case "Data/SetJobField":
        return {
          ...state,
          job: {
            ...state.job,
            ...action.data
          }
        };
      case "Data/SetRentalField":
        return {
          ...state,
          rental: {
            ...state.rental,
            ...action.data
          }
        };
      case "Data/SetQuoteField":
        return {
          ...state,
          quote: {
            ...state.quote,
            ...action.data
          }
        };
      case "Data/SetDiaryData":
        return {
          ...state,
          diary: action.data
        };
      case "Data/SetWorkData":
        return {
          ...state,
          work: action.data
        };
      case "Data/SetFinanceData":
        let agreements = action.data;
        agreements.results = action.data.results.map(agreement => {
          return {
            ...agreement,
            remaining_balance: getOutstandingBalance({...agreement}),
            hp_remaining_interest: getRemainingInterest({...agreement}, new Date(Date.now())),
            early_settlement_charges: 1 * getOutstandingBalance({...agreement}) + 1 * getLastMonthInterest({...agreement}, new Date(Date.now())),
            estimated_value: getEstimatedValue({...agreement}),
            hp_interest_rate: getHpInterestRate({...agreement}),
            this_months_payment: getThisMonthsPayment(
              {...agreement},
              new Date(Date.now())
            )
          }
        });
        return {
          ...state,
          finance: agreements
        };
      case
      "Data/SetVehiclesData":
        let newVehicles = action.data;
        newVehicles.results = newVehicles.results.map(vehicle => {
          return {
            ...vehicle,
            remaining_balance: getOutstandingBalance(vehicle),
            early_settlement_charges: getOutstandingBalance(vehicle) + getLastMonthInterest(vehicle, new Date(Date.now())),
            hp_remaining_interest: getRemainingInterest(vehicle, new Date(Date.now())),
            // estimated_value: getEstimatedValue(vehicle),
            hp_interest_rate: getHpInterestRate(vehicle),
            finance_agreements: vehicle.finance_agreements.map(agreement => {
              return {
                ...agreement,
                remaining_balance: getOutstandingBalance({...agreement}),
                hp_remaining_interest: getRemainingInterest({...agreement}, new Date(Date.now())),
                early_settlement_charges: 1 * getOutstandingBalance({...agreement}) + 1 * getLastMonthInterest({...action.data}, new Date(Date.now())),
                estimated_value: getEstimatedValue({...agreement}),
                hp_interest_rate: getHpInterestRate({...agreement}),
                this_months_payment: getThisMonthsPayment(
                  {...agreement},
                  new Date(Date.now())
                )
              }
            }),
          };
        });
        return {
          ...state,
          vehicles: newVehicles
        };
      case
      "Data/SetContactData"
      :
        return {
          ...state,
          contact: {...state.contact, ...action.data}
        };
      case
      "Data/SetContactsData"
      :
        return {
          ...state,
          contacts: action.data
        };
      case
      "Data/SetBlankContactData"
      :
        return {
          ...state,
          contact: {...action.data}
        };
      case
      "Data/SetAppDefaultsData"
      :
        return {
          ...state,
          appDefaults: action.data
        };
      case "Data/SetQuickLinksData":
        return {
          ...state,
          quickLinks: action.data
        };
      case "Data/SetDepartmentsData":
        return {
          ...state,
          departments: action.data
        };
      case "Data/SetFittersData":
        return {
          ...state,
          fitters: action.data
        };
      case "Data/SetKeysData":
        return {
          ...state,
          keys: action.data
        }
      case "Data/SetDefectCountData":
        return {
          ...state,
          defectCount: action.data
        }
      case "Data/SetEnquiryCountData"  :
        return {
          ...state,
          enquiryCount: action.data
        }
      case "Data/SetImagesData":
        return {
          ...state,
          images: action.data
        }
      case "Data/SetVehicleTrackerTypeData":
        return {
          ...state,
          vehicleTrackerType: action.data
        }
      case "Data/SetVehicleTrackerFigureData":
        return {
          ...state,
          vehicleTrackerFigures: action.data
        }
      case "Data/SetVehicleMakeData":
        return {
          ...state,
          vehicleMake: action.data
        }
      case "Data/SetRentalMarginData":
        return {
          ...state,
          rentalMargin: action.data
        }
      case "Data/SetVehicleModelData":
        return {
          ...state,
          vehicleModel: action.data
        }
      case "Data/SetWorkTypeData":
        return {
          ...state,
          workType: action.data
        }
      case "Data/SetVehicleStatusCountData":
        return {
          ...state,
          vehicleStatusCount: action.data
        }
      case "Data/SetJobStatusCountData":
        return{
          ...state,
          jobStatusCount: action.data
        }
      case "Data/SetMovementFigureData":
        return{
          ...state,
          movementFigures: action.data
        }
      case "Data/SetWorkServiceData":
        return{
          ...state,
          serviceData: action.data
        }
      case "Data/SetPaymentTypesData":
        return{
          ...state,
          paymentTypes: action.data
        }
      case "Data/SetCreditNotesData":
        return{
          ...state,
          creditNotes: action.data
        }
      case "Data/SetMovementRateData":
        return{
          ...state,
          movementRates: action.data
        }
      case "Data/SetMovementsData":
        return{
          ...state,
          movements: action.data
        }
      case "Data/SetInvoicesData":
        return{
          ...state,
          invoices: action.data
        }
      case "Data/SetMovementTypesData":
        return {
          ...state,
          movementTypes: action.data
        }
      case "Data/SetDriversData":
        return {
          ...state,
          drivers: action.data
        }
      case "Data/SetCapTotalsData":
        return {
          ...state,
          capTotals: action.data
        }
      case "Data/SetTotalsData":
        return {
          ...state,
          homeTotals: action.data
        }
      case "Data/SetFixedExpenseData":
        return {
          ...state,
          fixedExpenses: action.data
        }
      case "Data/SetPartOrdersData":
        return {
          ...state,
          partOrders: action.data
        }
      case "Data/SetPartOrderData":
        return {
          ...state,
          partOrder: action.data
        }
      case "Data/SetPartOrderFigureData":
        return {
          ...state,
          partOrderFigure: action.data
        }
      case "Data/SetPartOrderFieldData":
        return {
          ...state,
          partOrder: {
            ...state.partOrder,
            ...action.data
          }
        };
      case "Data/SetNominalCodesData":
        return {
          ...state,
          nominalCodes: action.data
        }
      case "Data/SetTrackingCategoryData":
        return {
          ...state,
          trackingCategories: action.data
        }
      case "Data/SetInvoiceFiguresData":
        return {
          ...state,
          invoiceFigures: action.data
        }
      case "Data/SetTrackingOptionData":
        return {
          ...state,
          trackingOptions: action.data
        }
      case "Data/SetMovementData":
        return {
          ...state,
          movement: action.data
        }
      case "Data/SetRateCardsData":
          return {
              ...state,
              rateCards: action.data
          }
      case "Data/SetSummaryFiguresData":
          return {
            ...state,
            summaryFigures: action.data
          }
      case "Data/SetJobWorkshopConfigData":
          return{
            ...state,
            workshopConfig: action.data
          }
      case "Data/SetFitterHourData":
          return {
            ...state,
            fitterHours: action.data
          }
      case "Data/SetDefaultWorkData":
        return {
          ...state,
          defaultWork: action.data
        }
      case "Data/SetExistingJobData":
        return {
          ...state,
          exisingJobs: action.data
        }
      case "Data/SetUtilsData":
        return {
            ...state,
            departments: action.data['department'] ? {results: action.data['department']} : undefined,
            vehicleMake: action.data['make'] ? {results: action.data['make']} : undefined,
            vehicleModel: action.data['model'] ? {results: action.data['model']}: undefined,
            keys: action.data['key'] ? {results: action.data['key']} : undefined,
            workType: action.data['work_type'] ? {results: action.data['work_type']} : undefined,
            movementRates: action.data['movement_rate'] ? {results: action.data['movement_rate']} : undefined,
            movementTypes: action.data['movement_type'] ? {results: action.data['movement_type']} : undefined,
            drivers: action.data['driver'] ? {results: action.data['driver']} : undefined,
            trackingOptions: action.data['tracking'] ? {results: action.data['tracking']} : undefined,
            fitters: action.data['fitter'] ? {results: action.data['fitter']} : undefined,
            paymentTypes: action.data['payment_type'] ? {results: action.data['payment_type']} : undefined,
            nominalCodes: action.data['nominal'] ? {results: action.data['nominal']} : undefined,
            vehicleTypes: action.data['type'] ? {results: action.data['type']} : undefined,
            rateCards: action.data['rate_card'] ? {results: action.data['rate_card']} : undefined,
            rentalMargin: action.data['margin'] ? {results: action.data['margin']} : undefined,
            servicePacks: action.data['service_pack'] ? {results: action.data['service_pack']} : undefined
        }
      default:
        return state;
    }
  }
;

export default history =>
  combineReducers({
    router: connectRouter(history),
    data: dataReducer
  });
